// English translations index
import { commonEn } from './common';
import { formsEn } from './forms';
import { navigationEn } from './navigation';
import { vehiclesEn } from './vehicles';
import { pagesEn } from './pages';
import { homeEn } from './home';
import { footerEn } from './footer';
import { financingEn } from './financing';
import { consignmentsEn } from './consignments';
import { buyDirectEn } from './buyDirect';
import { weSearchForYouEn } from './weSearchForYou';
import { contactEn } from './contact';
import { aboutEn } from './about';
import { bookingEn } from './booking';
import { formsUiEn } from './formsUi';
import { catalogEn } from './catalog';
import { siteEn } from './site';

export const en = {
  common: commonEn,
  forms: formsEn,
  navigation: navigationEn,
  vehicles: vehiclesEn,
  home: homeEn,
  pages: pagesEn,
  footer: footerEn,
  financing: financingEn,
  consignments: consignmentsEn,
  buyDirect: buyDirectEn,
  weSearchForYou: weSearchForYouEn,
  contact: contactEn,
  about: aboutEn,
  booking: bookingEn,
  formsUi: formsUiEn,
  catalog: catalogEn,
  site: siteEn,
};
